export default "__VITE_ASSET__d78d2580__"